export default __webpack_public_path__ + "static/media/Mary.dc0b66c5.png";